// Localized display names for popular career titles. Falls back to the original title.
// Only used for display; API + storage remains in English so filters/search still work.

const HI = {
  "Doctor": "डॉक्टर",
  "Software Engineer": "सॉफ़्टवेयर इंजीनियर",
  "Data Scientist": "डेटा साइंटिस्ट",
  "Data Analyst": "डेटा एनालिस्ट",
  "Biomedical Engineer": "बायोमेडिकल इंजीनियर",
  "Research Scientist": "रिसर्च साइंटिस्ट",
  "Research Scientist (Collaborative Labs)": "रिसर्च साइंटिस्ट (सहयोगी लैब)",
  "Science Communicator": "विज्ञान संचारक",
  "Science Communicator / Educator": "विज्ञान संचारक / शिक्षक",
  "Teacher": "शिक्षक",
  "Educator": "शिक्षक",
  "Lawyer": "वकील",
  "Journalist": "पत्रकार",
  "Architect": "आर्किटेक्ट",
  "Civil Engineer": "सिविल इंजीनियर",
  "Mechanical Engineer": "मैकेनिकल इंजीनियर",
  "Electrical Engineer": "इलेक्ट्रिकल इंजीनियर",
  "Chartered Accountant": "चार्टर्ड अकाउंटेंट",
  "Entrepreneur": "उद्यमी",
  "Product Manager": "प्रोडक्ट मैनेजर",
  "UX Designer": "UX डिज़ाइनर",
  "Graphic Designer": "ग्राफ़िक डिज़ाइनर",
  "Fashion Designer": "फ़ैशन डिज़ाइनर",
  "Psychologist": "मनोवैज्ञानिक",
  "Nurse": "नर्स",
  "Pharmacist": "फ़ार्मासिस्ट",
  "Nutritionist": "पोषण-विशेषज्ञ",
  "Veterinarian": "पशु-चिकित्सक",
  "Pilot": "पायलट",
  "Chef": "शेफ़",
  "Musician": "संगीतकार",
  "Writer": "लेखक",
  "Content Creator": "कंटेंट क्रिएटर",
  "Marketing Manager": "मार्केटिंग मैनेजर",
  "Financial Analyst": "फ़ाइनेंशियल एनालिस्ट",
  "Investment Banker": "इनवेस्टमेंट बैंकर",
  "Economist": "अर्थशास्त्री",
  "Public Servant": "लोक सेवक",
  "IAS Officer": "IAS अधिकारी",
  "Social Worker": "समाज सेवक",
  "Historian": "इतिहासकार",
  "Sociologist": "समाजशास्त्री",
  "AI Engineer": "AI इंजीनियर",
  "Machine Learning Engineer": "मशीन लर्निंग इंजीनियर",
  "Cybersecurity Analyst": "साइबरसिक्योरिटी एनालिस्ट",
  "Environmentalist": "पर्यावरणविद्",
  "Agricultural Scientist": "कृषि वैज्ञानिक",
  "Sports Coach": "स्पोर्ट्स कोच",
  "Photographer": "फोटोग्राफर",
};

const PA = {
  "Doctor": "ਡਾਕਟਰ",
  "Software Engineer": "ਸਾਫਟਵੇਅਰ ਇੰਜੀਨੀਅਰ",
  "Data Scientist": "ਡਾਟਾ ਸਾਇੰਟਿਸਟ",
  "Data Analyst": "ਡਾਟਾ ਵਿਸ਼ਲੇਸ਼ਕ",
  "Biomedical Engineer": "ਬਾਇਓਮੈਡੀਕਲ ਇੰਜੀਨੀਅਰ",
  "Research Scientist": "ਰਿਸਰਚ ਸਾਇੰਟਿਸਟ",
  "Research Scientist (Collaborative Labs)": "ਰਿਸਰਚ ਸਾਇੰਟਿਸਟ (ਸਹਿਯੋਗੀ ਲੈਬ)",
  "Science Communicator": "ਸਾਇੰਸ ਸੰਚਾਰਕ",
  "Science Communicator / Educator": "ਸਾਇੰਸ ਸੰਚਾਰਕ / ਅਧਿਆਪਕ",
  "Teacher": "ਅਧਿਆਪਕ",
  "Educator": "ਅਧਿਆਪਕ",
  "Lawyer": "ਵਕੀਲ",
  "Journalist": "ਪੱਤਰਕਾਰ",
  "Architect": "ਆਰਕੀਟੈਕਟ",
  "Civil Engineer": "ਸਿਵਲ ਇੰਜੀਨੀਅਰ",
  "Mechanical Engineer": "ਮਕੈਨੀਕਲ ਇੰਜੀਨੀਅਰ",
  "Electrical Engineer": "ਇਲੈਕਟ੍ਰੀਕਲ ਇੰਜੀਨੀਅਰ",
  "Chartered Accountant": "ਚਾਰਟਰਡ ਅਕਾਊਂਟੈਂਟ",
  "Entrepreneur": "ਉੱਦਮੀ",
  "Product Manager": "ਪ੍ਰੋਡਕਟ ਮੈਨੇਜਰ",
  "UX Designer": "UX ਡਿਜ਼ਾਈਨਰ",
  "Graphic Designer": "ਗ੍ਰਾਫ਼ਿਕ ਡਿਜ਼ਾਈਨਰ",
  "Fashion Designer": "ਫੈਸ਼ਨ ਡਿਜ਼ਾਈਨਰ",
  "Psychologist": "ਮਨੋਵਿਗਿਆਨੀ",
  "Nurse": "ਨਰਸ",
  "Pharmacist": "ਫਾਰਮਾਸਿਸਟ",
  "Nutritionist": "ਪੋਸ਼ਣ-ਵਿਗਿਆਨੀ",
  "Veterinarian": "ਪਸ਼ੂ-ਡਾਕਟਰ",
  "Pilot": "ਪਾਇਲਟ",
  "Chef": "ਸ਼ੈੱਫ",
  "Musician": "ਸੰਗੀਤਕਾਰ",
  "Writer": "ਲੇਖਕ",
  "Content Creator": "ਕੰਟੈਂਟ ਕ੍ਰੀਏਟਰ",
  "Marketing Manager": "ਮਾਰਕੀਟਿੰਗ ਮੈਨੇਜਰ",
  "Financial Analyst": "ਵਿੱਤੀ ਵਿਸ਼ਲੇਸ਼ਕ",
  "Investment Banker": "ਇਨਵੈਸਟਮੈਂਟ ਬੈਂਕਰ",
  "Economist": "ਅਰਥ-ਸ਼ਾਸਤਰੀ",
  "Public Servant": "ਸਰਕਾਰੀ ਸੇਵਕ",
  "IAS Officer": "IAS ਅਫ਼ਸਰ",
  "Social Worker": "ਸਮਾਜ ਸੇਵਕ",
  "Historian": "ਇਤਿਹਾਸਕਾਰ",
  "Sociologist": "ਸਮਾਜ-ਸ਼ਾਸਤਰੀ",
  "AI Engineer": "AI ਇੰਜੀਨੀਅਰ",
  "Machine Learning Engineer": "ਮਸ਼ੀਨ ਲਰਨਿੰਗ ਇੰਜੀਨੀਅਰ",
  "Cybersecurity Analyst": "ਸਾਈਬਰ ਸੁਰੱਖਿਆ ਵਿਸ਼ਲੇਸ਼ਕ",
  "Environmentalist": "ਵਾਤਾਵਰਣ-ਵਿਦ",
  "Agricultural Scientist": "ਖੇਤੀਬਾੜੀ ਵਿਗਿਆਨੀ",
  "Sports Coach": "ਖੇਡ ਕੋਚ",
  "Photographer": "ਫੋਟੋਗ੍ਰਾਫ਼ਰ",
};

export function localizeCareer(title, lang) {
  if (!title) return title;
  if (lang === "hi") return HI[title] || title;
  if (lang === "pa") return PA[title] || title;
  return title;
}
